module.exports = __webpack_public_path__ + "assets/img/close-sidebar-icon.f0876611.svg";